export default (theme) => ({
  root: {},
  gridItem: {
    padding: theme.spacing(0),
    minWidth: '650px',
    minHeight: 'calc(-195px + 100vh)',
  },
  mapLegend: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  tableLegend: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  topSpacer: { height: '60px' },
  tableSettings: {
    alignItems: 'end',
    alignSelf: 'flex-end',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing(1),
  },
});
